<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">Kindly contact your registry authority to update your organisation details</p>
  <p><a href="javascript:;" (click)="goToSearch()">Search with a different organisation ID</a></p>
  <p><a href="{{ccsContactUrl}}" target="_blank">Submit a conflict/claim form</a></p>
</div>
